/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'

import {
	Button,
	Loader,
	ModalBase,
	Paragraph,
	SelectRadio,
	Title,
} from '@components/atoms'
import { Select } from '@components/atoms/SelectBase/Select'
import type { Option } from '@components/atoms/SelectBase/SelectMove'
import type { ListRankingResponse } from '@models/ranking.model'
import * as Avatar from '@radix-ui/react-avatar'
import { rankingAPI } from '@services/RankingAPI'
import { simulatedAPI } from '@services/SimulatedAPI'

import {
	AvatarDefault,
	Bench,
	BenchIcon,
	ImageIcon,
	ItemRank,
	ItemTable,
	Podium,
	Position,
	Rank,
	RankingStyles,
} from './style'

const {
	container,
	containerTitle,
	title,
	boxSelects,
	boxSelect,
	table,
	itemImageNew,
} = RankingStyles

const orderRankingShow = [
	{
		order: 1,
		position: 'second',
	},
	{
		order: 0,
		position: 'first',
	},
	{
		order: 2,
		position: 'third',
	},
]
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let reorderedArray: any[] = []

export const Ranking = () => {
	const [data, setData] = useState<ListRankingResponse>()
	const [options, setOptions] = useState<
		Array<{
			value: string | number
			option: string
		}>
	>([{ value: 0, option: 'Ranking Geral' }])

	const [optionsModal, setOptionsModal] = useState<Array<Option>>()

	const [limit, setLimit] = useState<{
		value?: string | number
		option?: string
	}>({
		value: 10,
		option: '10',
	})

	const [simulate, setSimulate] = useState(0)
	const [simulatedId, setSimulatedId] = useState<{
		value?: string | number
		option?: string
	}>()

	const [openModal, setOpenModal] = useState(false)

	const [
		getRanking,
		{
			data: dataRanking,
			isSuccess: isSuccessRanking,
			isLoading: isLoadingSuccessRanking,
		},
	] = rankingAPI.useListMutation()

	const [
		getRankingSimulated,
		{
			data: dataRankingSimulated,
			isSuccess: isSuccessRankingSimulated,
			isLoading: isLoadingRankingSimulated,
		},
	] = rankingAPI.useGetMutation()

	const [
		getAllSimulated,
		{ data: dataAllSimulated, isSuccess: isSuccessAllSimulated },
	] = simulatedAPI.useGetAllSimulatedMutation()

	const [
		getWeeksSimulate,
		{ data: dataWeeksSimulate, isSuccess: isSuccessWeeksSimulate },
	] = simulatedAPI.useGetWeeksSimulateMutation()

	const handleSelect = () => {
		setOpenModal(false)
	}

	useEffect(() => {
		getAllSimulated({ page: 1, limit: 20 })
	}, [])

	useEffect(() => {
		if (simulatedId && simulatedId.value !== 0) return
		getRanking({
			page: 1,
			limit: limit.value,
		})
	}, [limit, simulatedId])

	useEffect(() => {
		if (simulatedId) {
			if (simulatedId.value === 0) {
				setData(dataRanking)
			} else {
				getRankingSimulated({
					id: simulatedId?.value as number,
					page: 1,
					limit: limit.value,
				})
			}
			reorderedArray = []
		}
	}, [simulatedId, limit])

	useEffect(() => {
		if (isSuccessRanking) {
			setData(dataRanking)
			reorderedArray = []
		}
	}, [isSuccessRanking])

	useEffect(() => {
		if (isSuccessRankingSimulated && dataRankingSimulated) {
			setData(dataRankingSimulated)
			reorderedArray = []
		}
	}, [isSuccessRankingSimulated])

	useEffect(() => {
		if (isSuccessAllSimulated && dataAllSimulated) {
			const arraySelect = dataAllSimulated.items.map((item) => {
				return { value: item.id, option: item.name }
			})

			setOptions([...options, ...arraySelect])
		}
	}, [isSuccessAllSimulated, dataAllSimulated])

	useEffect(() => {
		if (isSuccessWeeksSimulate && dataWeeksSimulate) {
			const arraySelect = dataWeeksSimulate.data.map((item) => {
				return { value: item.id, option: item.name }
			})

			setOptionsModal(arraySelect)
		}
	}, [isSuccessWeeksSimulate])

	const onSelectSimulate = useCallback(
		(item: Option) => {
			if (item.value === 0) {
				setSimulatedId({ option: '', value: 0 })
			} else {
				setOpenModal(true)
				getWeeksSimulate({
					page: 1,
					limit: 1000,
					categoryId: item.value as number,
				})
				setSimulate(item.value as number)
			}
		},
		[getWeeksSimulate]
	)

	return (
		<div className={container()}>
			<div>
				<div className={containerTitle()}>
					<div className={title()}>
						<Title variant='h1' color='$neutral160'>
							Ranking
						</Title>
					</div>
					<div className={boxSelects()}>
						<div className={boxSelect()}>
							<Select
								placeholder='Simulados'
								onChange={(item) => onSelectSimulate(item)}
								options={options}
								css={{
									maxWidth: '100%',
									gap: '0px',
								}}
								selectedValue={simulate}
							/>
						</div>
						<div className={boxSelect()}>
							<Select
								placeholder='Número de posições'
								onChange={setLimit}
								options={[
									{ value: 10, option: '10' },
									{ value: 30, option: '30' },
									{ value: 50, option: '50' },
									{ value: 100, option: '100' },
								]}
								css={{
									maxWidth: '100%',
									gap: '0px',
								}}
							/>
						</div>
					</div>
				</div>
				{data?.data &&
					data?.data.length > 0 &&
					!isLoadingRankingSimulated &&
					!isLoadingSuccessRanking && (
						<>
							<Rank>
								{orderRankingShow.map(({ position, order }, index) => {
									reorderedArray.push(data?.data[order])
									const findIndividual = reorderedArray[index]

									return (
										findIndividual && (
											<Podium key={index}>
												<Position>
													{findIndividual.photoUrl ? (
														<Avatar.Root>
															<Avatar.AvatarImage
																src={findIndividual?.photoUrl || ''}
																alt={findIndividual?.name || ''}
																className={itemImageNew()}
															/>
															<Avatar.AvatarFallback>
																<AvatarDefault>
																	<p className='charAtName'>
																		{findIndividual?.name
																			.charAt(0)
																			.toUpperCase()}
																	</p>
																</AvatarDefault>
															</Avatar.AvatarFallback>
														</Avatar.Root>
													) : (
														<AvatarDefault>
															<p className='charAtName'>
																{findIndividual?.name.charAt(0).toUpperCase()}
															</p>
														</AvatarDefault>
													)}

													<Paragraph
														paragraphType='p2'
														css={{
															color: '$neutral120',
														}}
													>
														{findIndividual?.name.split(' ')[0] || ''}
													</Paragraph>
												</Position>
												<Bench
													position={
														position === 'first' ||
														position === 'second' ||
														position === 'third'
															? position
															: 'none'
													}
												>
													<BenchIcon
														title={position}
														name={position}
														width='40'
														height='40'
													/>
												</Bench>
											</Podium>
										)
									)
								})}
							</Rank>

							<div className={table()}>
								{data?.data.map(
									({ photoUrl, name, rank, currentUser, position }, index) => {
										const positionIcons = {
											1: 'first',
											2: 'second',
											3: 'third',
										}

										return (
											<ItemTable myRank={currentUser > 0 && true} key={index}>
												<ItemRank>
													{index + 1 > 3 && position}
													{index + 1 <= 3 && (
														<ImageIcon
															title={positionIcons[(index + 1) as 1 | 2 | 3]}
															name={positionIcons[(index + 1) as 1 | 2 | 3]}
															width={28}
															height={28}
														/>
													)}
												</ItemRank>
												{photoUrl ? (
													<Avatar.Root>
														<Avatar.AvatarImage
															src={photoUrl}
															className={itemImageNew()}
														/>

														<Avatar.AvatarFallback>
															<AvatarDefault>
																<p className='charAtName'>
																	{name.charAt(0).toUpperCase()}
																</p>
															</AvatarDefault>
														</Avatar.AvatarFallback>
													</Avatar.Root>
												) : (
													<AvatarDefault>
														<p className='charAtName'>
															{name.charAt(0).toUpperCase()}
														</p>
													</AvatarDefault>
												)}
												<Paragraph
													paragraphType='p2'
													css={{
														color: '$neutral120',
														marginLeft: '8px',
														marginRight: '8px',
														'@lg': {
															fontSize: '$lg',
															letterSpacing: '0.8px',
														},
													}}
												>
													{name}
												</Paragraph>
												<Paragraph
													paragraphType='p3'
													css={{
														color: '$blue20',
														textAlign: 'end',
														minWidth: '37px',
														'@lg': {
															fontSize: '$lg',
															letterSpacing: '0.8px',
														},
													}}
												>
													{rank}
												</Paragraph>
											</ItemTable>
										)
									}
								)}
							</div>
						</>
					)}

				{(isLoadingRankingSimulated || isLoadingSuccessRanking) && <Loader />}

				{isSuccessRanking &&
					isSuccessRankingSimulated &&
					data?.data.length === 0 && (
						<div className='flex items-center'>
							<Title variant='h2' color='#000000'>
								Nenhum ranking encontrado
							</Title>
						</div>
					)}
			</div>

			<ModalBase
				title='Escolha o simulado'
				open={openModal}
				onOpenChange={() => {
					setOpenModal(false)
				}}
			>
				<div
					style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
				>
					<div
						style={{
							marginTop: '34px',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<SelectRadio
							options={optionsModal || []}
							onChange={(e) => {
								setSimulatedId({ option: e.option, value: e.value })
							}}
							value={simulatedId?.value}
						/>

						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: '26px',
								marginTop: '17px',
								paddingLeft: '16px',
							}}
						>
							<Button css={{ maxWidth: '164px' }} onClick={handleSelect}>
								Confirmar
							</Button>
							<Button
								outlined
								css={{ maxWidth: '164px' }}
								color='secondary'
								onClick={() => {
									setSimulate(0)
									setOpenModal(false)
									setSimulatedId({ value: 0, option: '' })
								}}
							>
								Cancelar
							</Button>
						</div>
					</div>
				</div>
			</ModalBase>
		</div>
	)
}
